import { addDimensions } from '@eventbrite/site-analytics';
import React from 'react';
import {
    IConfigContextProps,
    useConfigContext,
} from '../../contexts/ConfigContext';
import {
    IFrontendContext,
    useFrontendContext,
} from '../../contexts/FrontendContext';
import { IUserContext, useUserContext } from '../../contexts/UserContext';
import Lookup from '../lookup/Lookup';
import Signup from '../signup/Signup';

export interface ICompleteSignupProps {
    routing?: any;
}

const CompleteSignup = ({ routing }: ICompleteSignupProps) => {
    const frontendContext: IFrontendContext = useFrontendContext();
    const userContext: IUserContext = useUserContext();
    const configContext: IConfigContextProps = useConfigContext();

    const verificationCodeFF =
        configContext?.featureFlags?.launchSignupWithVerificationCode;

    addDimensions({
        experimentId: verificationCodeFF
            ? 'VerificationCodeOn'
            : 'VerificationCodeOff',
    });

    let component = <Lookup routing={routing} />;

    if (
        frontendContext.state.signupSecondStep &&
        userContext.state.lookup.lookedAccount
    ) {
        component = <Signup routing={routing} />;
    }

    return component;
};

export default CompleteSignup;
